import React from 'react'

import Padding from 'components/Editor/Toolbar/Padding'
import { FieldGroup, FormField } from 'components/formKit'
import type { FONT_QUOTE_FIELDS } from 'services/Branding/fieldConfigs'

export interface IDefaultQuoteFontFormProps {
  font: typeof FONT_QUOTE_FIELDS
  children?: React.ReactNode
}

const DefaultQuoteFontForm: React.FC<IDefaultQuoteFontFormProps> = ({ font, children }) => {
  return (
    <Padding gap sides>
      {children}
      <FieldGroup config={font.fontStyleGroup}>
        <FormField config={font.fontWeight} />
        <FormField config={font.fontStyle} />
      </FieldGroup>
      <FormField config={font.lineHeight} />
      <FormField config={font.color} />
      <FormField config={font.borderLeftColor} />
    </Padding>
  )
}

export default DefaultQuoteFontForm
